module.exports = __webpack_public_path__ + "media/images/sports_icons/pick-a-sport-e8e96630490520a65c9b35dd3532d553.png";